<template>
  <Fragment>
    <template v-if="$route.name !== 'mediaTypeIndex'">
      <router-view></router-view>
    </template>
    <section class="container" v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content"></section>
      </div>
      <el-row>
        <el-col :span="11"
          ><div class="grid-content bg-purple">
            <el-table :data="mediaList" style="width: 100%" border>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (mediaPageNum - 1) * mediaPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="媒体大类" width="260">
                <template slot-scope="scope">
                  <span
                    @click="getInfoByMediaTypesId(scope.row)"
                    style="color: #409EFF"
                    >{{ scope.row.mediaTypesName }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="节点标识" :fit="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.mediaTypesCode }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager, next, jumper"
              :total="mediaTotal"
              :page-size="10"
              :current-page="mediaPageNum"
              @prev-click="handlePrePage"
              @next-click="handleNextPage"
              @current-change="handleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
        <el-col :span="13"
          ><div class="grid-content bg-purple-light">
            <el-table :data="mediaSubList" style="width: 100%" border>
              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  <span>{{
                    scope.$index + (mediaSubPageNum - 1) * mediaSubPageSize + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column label="媒体小类" width="305">
                <template slot-scope="scope">
                  <span>{{ scope.row.mediaTypesName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="节点标识" :fit="true">
                <template slot-scope="scope">
                  <span>{{ scope.row.mediaTypesCode }}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="mt-20 pagination"
              background
              layout="total,prev, pager, next, jumper"
              :total="mediaSubTotal"
              :page-size="10"
              :current-page="mediaSubPageNum"
              @prev-click="brandHandlePrePage"
              @next-click="brandHandleNextPage"
              @current-change="brandHandleCurrentChange"
            >
            </el-pagination></div
        ></el-col>
      </el-row>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import Breadcrumb from "@/components/Breadcrumb";

export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      mediaTypesId: "",
      mediaList: [],
      mediaPageNum: 1,
      mediaPageSize: 10,
      mediaTotal: 0,
      mediaSubList: [],
      mediaSubPageNum: 1,
      mediaSubPageSize: 10,
      mediaSubTotal: 0
    };
  },
  methods: {
    //左侧获取媒体大类信息
    getMediaInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryMedia/getMediaTypesPage",
        params: {
          mediaTypesId: 0,
          pageNum: _this.mediaPageNum,
          pageSize: _this.mediaPageSize
        }
      };

      _this.$store.dispatch("getMediaTypeList", param).then(() => {
        _this.mediaList = _this.$store.state.mediaType.mediaTypeList.list;
        _this.mediaTotal = _this.$store.state.mediaType.mediaTypeList.total;
        _this.mediaTypesId = _this.mediaList[0].mediaTypesId;
        _this.getMediaSubInfo();
      });
    },
    //右侧获取媒体小类信息
    getMediaSubInfo() {
      let _this = this;
      let param = {
        url: "/api/dictionaryMedia/getMediaTypesPage",
        params: {
          mediaTypesId: _this.mediaTypesId,
          pageNum: _this.mediaSubPageNum,
          pageSize: _this.mediaSubPageSize
        }
      };

      _this.$store.dispatch("getMediaTypeList", param).then(() => {
        _this.mediaSubList = _this.$store.state.mediaType.mediaTypeList.list;
        _this.mediaSubTotal = _this.$store.state.mediaType.mediaTypeList.total;
      });
    },
    //右侧媒体小类查询
    searchMediaSub() {
      let _this = this;
      _this.getMediaSubInfo();
    },
    //媒体大类点击触发事件
    getInfoByMediaTypesId(row) {
      let _this = this;
      _this.mediaTypesId = row.mediaTypesId;
      _this.getMediaSubInfo();
    },
    //左侧当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.mediaPageNum = value;
      _this.getMediaInfo();
    },
    //左侧上一页
    handlePrePage() {
      let _this = this;
      _this.mediaPageNum -= 1;
      _this.getMediaInfo();
    },
    //左侧下一页
    handleNextPage() {
      let _this = this;
      _this.mediaPageNum += 1;
      _this.getMediaInfo();
    },
    //右侧当前页
    brandHandleCurrentChange(value) {
      let _this = this;
      _this.mediaSubPageNum = value;
      _this.searchMediaSub();
    },
    //右侧上一页
    brandHandlePrePage() {
      let _this = this;
      _this.mediaSubPageNum -= 1;
      _this.searchMediaSub();
    },
    //右侧下一页
    brandHandleNextPage() {
      let _this = this;
      _this.mediaSubPageNum += 1;
      _this.searchMediaSub();
    }
  },
  created() {
    let _this = this;
    _this.getMediaInfo();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
      display: flex
      align-items: center
      justify-content: space-between

      .left
          display: flex

      .el-button
          font-size: 14px

      .search-name, .search-code
          font-size: 14px
          display: flex
          align-items: center

          span
              white-space: nowrap

  .pagination
      text-align: center
</style>
